import React, { useState, useEffect, useCallback, useRef } from "react";
import { Card } from "react-bootstrap";
import { useParams } from "react-router-dom";
import toastr from "toastr";

import FormA from "../FormA/FormA.component";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { contractorFormAFields, initialContractorFormA } from "./Constant";
import {
  getContractorPersonById,
  updateContractorFormA,
} from "app/_services/UserManagement/ContractorPersonService";
import { URL_CONFIG } from "app/_constants/Config/URL_CONFIG";

function EditContractorFormA() {
  const [form, setForm] = useState(() => ({
    ...initialContractorFormA,
  }));
  const processingRef = useRef(false);

  const { id } = useParams();

  const onChange = useCallback(
    ({ target: { name, value } }) =>
      setForm((prevForm) => ({ ...prevForm, [name]: value })),
    []
  );

  const onSubmit = useCallback(
    async (event) => {
      event.preventDefault();
      if (processingRef.current) return;

      const formData = new FormData();

      Object.keys(contractorFormAFields).forEach((key) =>
        contractorFormAFields[key].fields.forEach((field) => {
          if (field.readOnly) return;

          if (field.inputType !== "section")
            formData.append(field.name, form[field.name]);
          else for (const { name } of field.fields) formData.append(name, form[name]);
        })
      );

      const response = await updateContractorFormA(id, formData);

      setTimeout(() => {
        processingRef.current = false;
      }, 1000);

      if (!response?.status) {
        return toastr.error("Could not update!", "Error.");
      }

      toastr.success("Updated successfully.", "Success.");
    },
    [id, form]
  );

  useEffect(() => {
    if (!id) return;

    getContractorPersonById(id).then((response) => {
      if (!response?.data) return;
      const contractorData = response.data;

      setForm((prevForm) => ({
        ...prevForm,
        ...contractorData,
        startDateAtMines: contractorData.startDateAtMines?.slice(0, 10) || "",
        dateOfJoining: contractorData.dateOfJoining?.slice(0, 10) || "",
        dateOfSeparation: contractorData.dateOfSeparation?.slice(0, 10) || "",
        siteType: contractorData?.ehsSite?.siteType || "",
        mineName: contractorData?.ehsSite?.name || "",
        mineCode: contractorData?.ehsSite?.siteId || "",
        fullName: `${contractorData.firstName || ""} ${contractorData.lastName || ""}`,
        ...(contractorData.contractorFormA || {}),
        contractorName: contractorData.contractors?.contractorLegalEntity || "",
        contractorCode: contractorData.contractors?.contractorCode || "",
        profilePicture: contractorData.contractorFormA?.profilePicture
          ? `${URL_CONFIG.IMG_URL}${contractorData.contractorFormA?.profilePicture}`
          : "",
      }));
    });
  }, [id]);

  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "User Management", path: "#" },
          {
            name: "Contractor Staff",
            path: "/user-management/contractor-person",
          },
          { name: "Edit Form A", path: "#" },
        ]}
      />

      <Card className="overflow-inherit">
        <Card.Body>
          <Card.Title className="simple-card-title mb-0">
            <h3 class="text-capitalize mb-1">Edit Contractor Form A</h3>
          </Card.Title>
          <FormA
            fieldsObj={contractorFormAFields}
            form={form}
            id={id}
            onChange={onChange}
            onSubmit={onSubmit}
          />
        </Card.Body>
      </Card>
    </div>
  );
}

export default EditContractorFormA;
